import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const HailsRmaLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>Reale Group {`${t("riskAssessment.hail")}`} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#2A81BC")}></span>1 - {t("levels.veryLow")}
      </div>
      <div>
        <span style={legendItemStyle("#8FCCA7")}></span>2 - {t("levels.low")}
      </div>
      <div>
        <span style={legendItemStyle("#DCF2B2")}></span>3 - {t("levels.medium")}
      </div>
      <div>
        <span style={legendItemStyle("#FEE196")}></span>4 - {t("levels.significant")}
      </div>
      <div>
        <span style={legendItemStyle("#F6924E")}></span>5 - {t("levels.high")}
      </div>
      <div>
        <span style={legendItemStyle("#D91C15")}></span>6 - {t("levels.veryHigh")}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © Reale Group, {t("legend.dataFromRealeGroup")}
        </span>
      </div>
    </div>
  );
};
